import styled from 'styled-components';

export const Base = styled.div`
	height: 48px;
	padding-left: 10px;
	padding-right: 14px;
	display: flex;
	align-items: center;
	background: transparent;
`;

export const Label = styled.div`
	// layout
	display: inline-block;
	align-items: center;
	margin-top: -2px;

	// style
	user-select: none;
	font-size: 14px;
	font-family: 'Inter', sans-serif;
	font-weight: 500;
	color: ${({ theme }) => theme.gray['1000']};
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
`;

export const Icon = styled.div`
	padding: 4px;
	color: ${({ theme }) => theme.gray['1000']};
	margin-right: 4px;
`;
